/**
 * A stored level sentence as a teacher reads it: reports written before the
 * label became ours open with the students' word, "Teamwork Level 3: ...".
 * Only those two leading words change; the rest is the report's own text.
 *
 * @param {string} text The level sentence a report stored.
 * @returns {string} The same sentence, opening with "Collaboration Level".
 */
export const collaborationLevelWording = (text) =>
  text.replace(/^\s*teamwork\s+level\b/i, 'Collaboration Level');
